<template>
  <v-container fluid class="webConDirectDean-management mt-4 px-1">
    <v-row>


      <v-col cols="12">


        <v-card class="mb-1" v-if="state=='view-con-list'">

          <ConDirectDeanListManagement
              id="List_ConDirectDeanListManagement">

          </ConDirectDeanListManagement>


          <v-alert
              border="top"
              colored-border
              color="success"
              elevation="2"
          >

            <v-row align="center">
              <v-col class="grow">
                <v-avatar>
                  <img
                      :src="baseURLStorage+temp_data.direct_dean_image"

                  >
                </v-avatar>

                รหัสสมาชิก <strong>{{ temp_data.user_name }}</strong>
                ชื่อ-นามสกุล <strong>{{ displayTextName(temp_data.user_name) }}</strong>
              </v-col>
              <v-col class="shrink">
                <v-btn
                    color="primary"
                    outlined
                    class="button-shadow mr-4"
                    @click="close">
                  กลับสู่หน้าหลัก
                </v-btn>
              </v-col>
            </v-row>


          </v-alert>


        </v-card>




        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการทำเนียบคณบดี</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{
              '\xa0 (' + webConDirectDeans.length
            }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items="webConDirectDeans"
                :search="search"
                sort-by="direct_dean_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>


                </template>


              </template>

              <template v-slot:item.direct_dean_image="{ item }">

                <v-avatar>
                  <img
                      :src="baseURLStorage+item.direct_dean_image"
                      :alt="item.fname_th+' '+item.lname_th"
                  >
                </v-avatar>

              </template>

              <template v-slot:item.user_name="{ item }">
                <span>{{ displayTextName(item.user_name) }}</span>

              </template>






              <template v-slot:item.direct_dean_start_date="{ item }">
                <span> {{ dataFormatter.dateFormatterTH(item.direct_dean_start_date, 3) }}</span> -
                <span v-if="item.direct_dean_status_now=='N'"> {{ dataFormatter.dateFormatterTH(item.direct_dean_end_date, 3) }}</span>
                <span v-else> ปัจจุบัน</span>

              </template>






              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>

                <v-btn
                    @click="viewConList(item,'T1')"
                    small
                    class="mr-3 button-shadow darken-2 white--text"
                    color="yellow"
                >บริหาร
                </v-btn>

                <v-btn
                    @click="viewConList(item,'T2')"
                    small
                    class="mr-3 button-shadow accent-2 white--text"
                    color="indigo"
                >รางวัล
                </v-btn>

                <v-btn
                    @click="viewConList(item,'T3')"
                    small
                    class="mr-3 button-shadow accent-1 white--text"
                    color="deep-purple"

                >เครื่องราษฎร์
                </v-btn>


                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }} : </p>

            <span>  {{
                currentUser.user_name
              }}</span>


          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row justify="space-between">
                <v-col cols="3" sm="3">

                  <v-row>
                    <v-col class="d-flex" cols="12" sm="12" v-if="state=='addForm'">

                      <v-file-input
                          @change="previewImage"
                          v-model="editForm.avatarFile"
                          show-size
                          chips
                          :rules="editForm.textReqRules.concat(editForm.imageRules)"
                          accept="image/*"
                          placeholder="Pick an avatar"
                          prepend-icon="mdi-camera"
                          label="ภาพโปรไฟล์"
                      ></v-file-input>


                    </v-col>
                    <v-col class="d-flex" cols="12" sm="12" v-if="state=='addForm'">

                      <v-col v-if="editForm.preview==''">
                        <v-row
                            class="fill-height"
                            align-content="center"
                            justify="center"
                        >
                          <v-col
                              class="text-subtitle-1 text-center"
                              cols="12"
                          >
                            เลือกไฟล์เพื่อแสดงผล
                          </v-col>
                          <v-col cols="6">
                            <v-progress-linear
                                color="deep-purple accent-4"
                                indeterminate
                                rounded
                                height="6"
                            ></v-progress-linear>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col v-else>
                        <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                      </v-col>


                    </v-col>


                    <v-col class="d-flex" cols="12" sm="12" v-if="state=='editForm'">

                      <v-file-input
                          @change="previewImage"
                          v-model="editForm.avatarFile"
                          show-size
                          chips
                          :rules="editForm.imageRules"
                          accept="image/*"
                          placeholder="Pick an avatar"
                          prepend-icon="mdi-camera"
                          label="ภาพโปรไฟล์ใหม่"
                      ></v-file-input>

                    </v-col>
                    <v-col class="d-flex" cols="12" sm="12" v-if="state=='editForm'">

                      <v-card v-if="editForm.preview==''">
                        <v-img
                            :src="baseURLStorage+editForm.avatarFileOld"
                            :alt="editForm.fname_th+' '+editForm.lname_th"
                            style="max-width: 100%"
                        ></v-img>

                      </v-card>
                      <v-card v-else>
                        <img v-bind:src="editForm.preview" style="max-width: 100%"/>
                      </v-card>


                    </v-col>


                  </v-row>

                </v-col>

                <v-col cols="9" sm="9">
                  <v-row align="center">


                    <v-col class="d-flex" cols="12" sm="4">

                      <v-select
                          v-model="editForm.user_name"
                          :rules="editForm.textReqRules"
                          :items="directDean_users_combo"
                          item-text="full_name_th"
                          item-value="user_name"
                          label="ข้อมูลบุคลากร"
                          clearable=""
                          required
                      ></v-select>

                    </v-col>

                    <v-col class="d-flex" cols="12" sm="3">


                      <v-menu
                          v-model="menu"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="dateFormatted"
                              :rules="editForm.textReqRules"
                              label="วันที่เริ่มต้น"
                              hint="วัน/เดือน/พ.ศ."
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date"
                            :rules="editForm.textReqRules"
                            :first-day-of-week="1"
                            locale="th"
                            @input="menu = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="2">
                      <!--Y="ปัจจุบัน"-->
                      <v-switch
                          v-model="editForm.direct_dean_status_now"
                          inset
                          color="secondary"
                          true-value="N"
                          false-value="Y"
                          :rules="editForm.textReqRules"
                          label="วาระสิ้นสุด"
                          required
                      ></v-switch>

                    </v-col>

                    <v-col class="d-flex" cols="12" sm="3">


                      <v-menu
                          v-if="editForm.direct_dean_status_now=='N'"
                          v-model="menu2"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                              v-model="dateFormatted2"
                              :rules="editForm.textReqRules"
                              label="วันที่สิ้นสุด"
                              hint="วัน/เดือน/พ.ศ."
                              persistent-hint
                              prepend-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="date2"
                            :rules="editForm.textReqRules"
                            :first-day-of-week="1"
                            locale="th"
                            @input="menu2 = false"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>

                  </v-row>

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="6">

                      <v-textarea
                          rows="2"
                          v-model="editForm.direct_dean_position_th"
                          :rules="editForm.textReqRules"
                          label="ชื่อตำแหน่งบริหาร (TH)"
                          required
                      ></v-textarea>
                    </v-col>

                    <v-col class="d-flex" cols="12" sm="6">
                      <v-textarea
                          rows="2"
                          v-model="editForm.direct_dean_position_en"
                          :rules="editForm.textReqRules"
                          label="ชื่อตำแหน่งบริหาร (EN)"
                          required
                      ></v-textarea>

                    </v-col>

                  </v-row>


                  <v-row align="center">


                    <v-col class="d-flex" cols="12" sm="2">

                      <v-switch
                          v-model="editForm.active"
                          inset
                          color="success"
                          true-value="Y"
                          false-value="N"
                          :rules="editForm.textReqRules"
                          label="ใช้งาน"
                          required
                      ></v-switch>

                    </v-col>


                  </v-row>

                  <v-row align="center">

                    <v-col class="d-flex" cols="12" sm="12">
                      <v-row justify="end">
                        <v-btn
                            color="secondary"
                            outlined
                            class="button-shadow mr-4"
                            @click="cancelForm">
                          ยกเลิก
                        </v-btn>
                        <v-btn
                            color="primary"
                            outlined
                            class="button-shadow mr-4"
                            @click="reset"
                            v-if="state=='addForm'">
                          ล้างข้อมูล
                        </v-btn>
                        <v-btn
                            :disabled="!editForm.valid"
                            color="primary"
                            class="button-shadow mr-4"
                            @click="validate">
                          บันทึก
                        </v-btn>
                      </v-row>

                    </v-col>

                  </v-row>

                </v-col>


              </v-row>


            </v-form>
          </v-card-text>


        </v-card>


      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapMutations, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
// import Editor from '@tinymce/tinymce-vue';
// import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";
import dataFormatter from "@/use/dataFormatter";
import ConDirectDeanListManagement from "@/pages/WebContent/ConDirectDeanListManagement/ConDirectDeanListManagement";

export default {
  name: 'ConDirectDeanManagement',
  data() {
    return {
      date: '',
      date2: '',
      date3: '',
      dateFormatted: '',
      dateFormatted2: '',
      dateFormatted3: '',
      //กรณีกำหนดค่าเริ่มต้น
      // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      // date3: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),

      // dateFormatted: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      // dateFormatted2: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      // dateFormatted3: this.formatDate((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)),
      modal: false,
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,

      //
      datemonth: (new Date().toISOString().substr(0, 7)),
      datemonthFormatted: this.formatDateMonth((new Date().toISOString().substr(0, 7))),

      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      baseURLStorage: config.baseURLStorage,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        user_name: "",
      },
      selected: [],
      headers: [
        {text: 'รูปโปรไฟล์', align: 'start', value: 'direct_dean_image'},
        {text: 'สมาชิก', value: 'user_name'},

        {text: 'ตำแหน่ง', value: 'direct_dean_position_th'},

        {text: 'ระยะเวลา', value: 'direct_dean_start_date'},


        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],


      directDean_users_combo: [],
      directDean_users_combo_all: [],
      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {},
      checkboxModel: [], // [] * {} ไม่เหมือนกันระวังการใช้ รวมกับ multiselect

    }
  },
  components: {
    ConDirectDeanListManagement
    // 'editor': Editor, // <- Important part
    // UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_direct_deans', ['webConDirectDeans', "isReceiving", "isDeleting", "idToDelete", "webConDirectDeanMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
    dataFormatter() {
      return dataFormatter;
    },

    //Date Picker Format
    computedDateFormatted() {
      return this.formatDate(this.date)
    },

    //Date Picker Format
    computedDateFormatted2() {
      return this.formatDate(this.date2)
    },

    //Date Picker Format
    computedDateFormatted3() {
      return this.formatDate(this.date3)
    },

    computedDateMonthFormatted() {
      return this.formatDateMonth(this.datemonth)
    },
    //getDataUserLogin

    ...mapState('auth', {
      currentUser: (state) => state.currentUser,
    }),
    ...mapState({
      data: (state) => state.usersForm.data,
    }),
  },
  async beforeMount() {

  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConDirectDeanMessage() {

      if (this.webConDirectDeanMessage !== '') {
        this.notification = this.webConDirectDeanMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {

          this.addSuccessNotification();

        }
        this.close();
      }
    },

    //Date Picker Format
    date() {
      this.dateFormatted = this.formatDate(this.date)
    },
    date2() {
      this.dateFormatted2 = this.formatDate(this.date2)
    },
    date3() {
      this.dateFormatted3 = this.formatDate(this.date3)
    },
    datemonth() {
      this.datemonthFormatted = this.formatDateMonth(this.datemonth)
    },
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConDirectDeansRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();
  },
  methods: {

    //getDataUserLogin
    ...mapMutations({
      showSnackbar: 'snackbar/showSnackbar',
    }),
    ...mapActions({
      getData: 'usersForm/getData',
    }),

    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_direct_deans',
        [
          "getWebConDirectDeansRequest",
          "deleteWebConDirectDeanRequest",
          "updateWebConDirectDeanRequest",
          "createWebConDirectDeanRequest"
        ]
    ),
    ...mapActions('web_con_direct_dean_lists', [
      "getWeb_Con_Direct_Dean_ListsRequest"
    ]),

    resetValue() {


      this.editForm = {}
      this.editForm = {
        valid: true,
        numRules: validateRules.numRules,
        textReqRules: validateRules.textReqRules,
        imageRules: validateRules.fileSingleRules(3),
        fileRules: validateRules.fileSingleRules(100),
        direct_dean_id: null,
        active: 'Y',
        direct_dean_status_now: 'N',
        direct_dean_image: null,
        avatarFile: null,
        avatarFileOld: null,
        preview: '',

      }
      this.checkboxModel = []


    },

    async getDcParamCombobox() {

      try {


        const formData = new FormData();
        formData.append('role_group', 'web1');
        formData.append('role_page', '/web/content_activity');
        formData.append('check_role', '');

        await axios.post(config.baseURLApi + '/combo/' + 'usersActiveOwn', formData, {
          headers: {},
        }).then(res => {
          this.directDean_users_combo = res.data;
        });

        await axios.post(config.baseURLApi + '/combo/' + 'usersActive', {
          headers: {},
        }).then(res => {
          this.directDean_users_combo_all = res.data;
        });

      } catch (e) {
        this.showSnackbar(e);
      }


    },

    displayTextName(item) {
      return !this.directDean_users_combo.length == true ? '' : (this.directDean_users_combo.find(combobox => combobox.user_name === item)).fname_th+" "+(this.directDean_users_combo.find(combobox => combobox.user_name === item)).lname_th;

    },


    previewImage: function (event) {
      event == null ? this.editForm.preview = '' : this.editForm.preview = URL.createObjectURL(event)
    },

    addItem() {
      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.active = 'Y';
      this.editForm.direct_dean_status_now = 'N';
      this.editForm.avatarFile = null
      this.editForm.preview = '',
          this.state = 'addForm';

    },
    editItem(item) {
      this.resetValue();
      this.editedIndex = this.webConDirectDeans.indexOf(item) //index ของ row ที่จะแก้ไข

// *********************
      this.date = item.direct_dean_start_date;
      this.dateFormatted = this.formatDate(item.direct_dean_start_date); //start

      this.date2 = item.direct_dean_end_date;
      this.dateFormatted2 = this.formatDate(item.direct_dean_end_date); //end


// *********************

      this.editForm.direct_dean_id = item.direct_dean_id;
      this.editForm.user_name = item.user_name;
      this.editForm.avatarFileOld = item.direct_dean_image;
      this.editForm.direct_dean_image = item.direct_dean_image;
      this.editForm.direct_dean_start_date = item.direct_dean_start_date;
      this.editForm.direct_dean_end_date = item.direct_dean_end_date;
      this.editForm.direct_dean_status_now = item.direct_dean_status_now;
      this.editForm.direct_dean_position_th = item.direct_dean_position_th;
      this.editForm.direct_dean_position_en = item.direct_dean_position_en,
          this.editForm.active = item.active;

      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConDirectDeanRequest({direct_dean_id: item.direct_dean_id})

    },
    viewConList(item,direct_dean_list_type) {
      this.temp_data = null;
      this.temp_data = item;
      this.getWeb_Con_Direct_Dean_ListsRequest({
        user_name: item.user_name,
        direct_dean_list_type: direct_dean_list_type,

      });
      this.state = "view-con-list";
    },
    close() {

      if (this.errorMessage == false || this.webConDirectDeanMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      
      if(!this.checkStartEnd()){
        return false;

      }

      this.editForm.direct_dean_start_date = this.date;
      this.editForm.direct_dean_end_date = this.date2;
      this.editForm.checkbox_select = this.checkboxModel;

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConDirectDeans[this.editedIndex], this.editForm)
            :
            this.updateWebConDirectDeanRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConDirectDeans.push(this.editForm)
            :
            this.createWebConDirectDeanRequest(this.editForm)
      }


    },

    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    async reset() {
      await this.$refs.form.reset()
      this.resetValue()
    },
    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },

    //Date Picker Format

    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${(year) * 1 + 543}`
    },
    formatDateMonth(date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${(year) * 1 + 543}`
    },

    parseDate(date) {
      if (!date) return null
      const [month, day, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    parseDateMonth(date) {
      if (!date) return null
      const [month, year] = date.split('/')
      return `${(year) * 1 - 543}-${month.padStart(2, '0')}`
    },
    searchData() {


      this.getWebConDirectDeansRequest(this.search_data);

      // console.log(this.search_data)
    },

    checkStartEnd() {
      if(this.editForm.direct_dean_status_now=='Y'){
        this.date2 = ''
      }
      if (this.date != '' && this.date2 != '') {

        // แปลง string เป็น Date objects
        var startDateObject = new Date(this.date);
        var endDateObject = new Date(this.date2);

        // เปรียบเทียบวันที่
        if (startDateObject > endDateObject) {
          alert("ข้อความเตือน: วันที่เริ่มต้น มากกว่า วันที่สิ้นสุด")
          this.date = ''
          return false;
          // console.log("ข้อความเตือน: start_date มากกว่า end_date");
        } else if (endDateObject < startDateObject) {
          alert("ข้อความเตือน: วันที่สิ้นสุด น้อยกว่า วันที่สิ้นสุด")
          this.date2 = ''
          return false;
          // console.log("ข้อความเตือน: end_date น้อยกว่า start_date");
        }else{
          return true;
        }

      }else{
        return true;
      }
    },

  },
}
</script>

<style src="./ConDirectDeanManagement.scss" lang="scss"/>
